/**
 * @generated SignedSource<<d674de2b1196960d40568bcae8a635c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberOnboardingBanner_SlackWorkspaceFragment$data = {
  readonly content: {
    readonly organization: {
      readonly slack: {
        readonly workspace: {
          readonly name: string | null;
          readonly url: string | null;
        } | null;
      } | null;
    };
  };
  readonly " $fragmentType": "MemberOnboardingBanner_SlackWorkspaceFragment";
};
export type MemberOnboardingBanner_SlackWorkspaceFragment$key = {
  readonly " $data"?: MemberOnboardingBanner_SlackWorkspaceFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberOnboardingBanner_SlackWorkspaceFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberOnboardingBanner_SlackWorkspaceFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Organization",
          "kind": "LinkedField",
          "name": "organization",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SlackConnection",
              "kind": "LinkedField",
              "name": "slack",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SlackWorkspace",
                  "kind": "LinkedField",
                  "name": "workspace",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "url",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentUsage",
  "abstractKey": null
};

(node as any).hash = "077278273831060a2413a18a561bf611";

export default node;
